document.addEventListener('alpine:init', () => {
  var { removeSectionWrapper } = Alpine.store('utilities');

  function productRecommendations(data = {}) {
    return {
      ...data,
  
      isLoading: false,
  
      onIntersect() {
        this.isLoading = true;
  
        fetch(this.url)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }
  
            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            Alpine.morph(this.$root, sectionHtml);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    };
  };

  Alpine.data('productRecommendations', productRecommendations);
});
